<oui-banner
  *ngIf="allocationService.allocationRule.showBanner"
  type="expandable"
  [declination]="allocationService.allocationRule.bannerDeclination"
  [title]="allocationService.allocationRule.bannerTitle"
  [showCloseButton]="false">
  <div class="messages">
    <li class="body-2 color-on-surface-medium" *ngIf="allocationService.allocationRule.showDispoEpargne">
      La <span class="bold color-on-surface-high-emphasis">disponibilité de l’épargne</span> sélectionnée dans la
      partie<span class="bold color-primary-500"> exigences et besoins du projet</span>, impose un profil de risque
      d'allocation sécurisé.
    </li>
    <li class="body-2 color-on-surface-medium" *ngIf="allocationService.allocationRule.showTolerancePerte">
      La capacité à supporter les pertes issue du profil investisseur
      <span class="color-alert">impose un profil de risque d'allocation sécurisé.</span>
    </li>
    <ng-container [ngSwitch]="allocationService.allocationRule.toleranceRisqueProjet">
      <li *ngSwitchCase="toleranceRisque.Securise" class="body-2 color-on-surface-medium">
        Le <span class="bold color-on-surface-high-emphasis">profil de risque du projet</span> sélectionné dans la
        partie<span class="bold color-primary-500"> exigences et besoins du projet</span>, impose un profil de risque
        d'allocation sécurisé.
      </li>
      <li *ngSwitchCase="toleranceRisque.Prudent" class="body-2 color-on-surface-medium">
        Le <span class="bold color-on-surface-high-emphasis">profil de risque du projet</span> sélectionné dans la
        partie<span class="bold color-primary-500"> exigences et besoins du projet</span>, impose un profil de risque
        d'allocation prudent ou sécurisé.
      </li>
      <li *ngSwitchCase="toleranceRisque.Equilibre" class="body-2 color-on-surface-medium">
        Le <span class="bold color-on-surface-high-emphasis">profil de risque du projet</span> sélectionné dans la
        partie<span class="bold color-primary-500"> exigences et besoins du projet</span>, impose un profil de risque
        d'allocation équilibré ou inférieur.
      </li>
      <li *ngSwitchCase="toleranceRisque.Dynamique" class="body-2 color-on-surface-medium">
        Le <span class="bold color-on-surface-high-emphasis">profil de risque du projet</span> sélectionné dans la
        partie<span class="bold color-primary-500"> exigences et besoins du projet</span>, impose un profil de risque
        d'allocation dynamique ou inférieur.
      </li>
    </ng-container>
    <ng-container [ngSwitch]="allocationService.allocationRule.horizonRetraite">
      <li *ngSwitchCase="horizonRetraite.AN_0_3" class="body-2 color-on-surface-medium">
        L’<span class="bold color-on-surface-high-emphasis">Horizon de placement</span> sélectionnée dans la partie<span
          class="bold color-primary-500">
          exigences et besoins du projet</span
        >, impose un profil de risque d’allocation sécurisé.
      </li>
      <li *ngSwitchCase="horizonRetraite.AN_3_5" class="body-2 color-on-surface-medium">
        L’<span class="bold color-on-surface-high-emphasis">Horizon de placement</span> sélectionné dans la partie
        <span class="bold color-primary-500"> exigences et besoins du projet</span>, impose un profil de risque
        d’allocation prudent ou sécurisé.
      </li>
    </ng-container>
    <ng-container [ngSwitch]="allocationService.allocationRule.horizonPlacement">
      <li *ngSwitchCase="horizonPlacement.De0A3Ans" class="body-2 color-on-surface-medium">
        L’<span class="bold color-on-surface-high-emphasis">Horizon de placement</span>sélectionné dans la partie
        <span class="bold color-primary-500"> exigences et besoins du projet</span>, impose un profil de risque
        d’allocation sécurisé.
      </li>
      <li *ngSwitchCase="horizonPlacement.De3A5Ans" class="body-2 color-on-surface-medium">
        L’<span class="bold color-on-surface-high-emphasis">Horizon de placement</span> sélectionné dans la partie
        <span class="bold color-primary-500">exigences et besoins du projet</span>, impose un profil de risque
        d’allocation prudent ou sécurisé.
      </li>
    </ng-container>
    <ng-container [ngSwitch]="allocationService.allocationRule.profilRisque">
      <ng-container *ngSwitchCase="profile.Securise">
        <li class="body-2 color-on-surface-medium">
          Le <span class="bold color-on-surface-high-emphasis"> profil de risque</span> déterminé dans le
          <span class="bold color-primary-500"> profil investisseur</span>, impose un profil de risque d'allocation
          sécurisé.
        </li>
      </ng-container>
      <ng-container *ngSwitchCase="profile.Prudent">
        <li class="body-2 color-on-surface-medium">
          Le <span class="bold color-on-surface-high-emphasis"> profil de risque</span> déterminé dans le
          <span class="bold color-primary-500"> profil investisseur</span>, ne permet pas d'avoir un profil de risque
          d'allocation offensif.
        </li>
      </ng-container>
      <ng-container *ngSwitchCase="profile.Equilibre">
        <li class="body-2 color-on-surface-medium">
          Le <span class="bold color-on-surface-high-emphasis"> profil de risque</span> déterminé dans le
          <span class="bold color-primary-500"> profil investisseur</span>, ne permet pas d'avoir un profil de risque
          d'allocation offensif.
        </li>
      </ng-container>
    </ng-container>
  </div>
</oui-banner>
